<a [routerLink]="link" class="button shadow-box text-center">
    <ng-content></ng-content>
</a>